var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "component-select-wrap" }, [
    _c(
      "div",
      {
        staticClass: "component-select area-select",
        on: {
          mouseover: _vm.changeEventHandler,
          mouseout: _vm.changeEventHandler
        }
      },
      [
        _c("CheckInput", {
          staticClass: "input-select noevent z2 w-normal",
          attrs: {
            isFocus: _vm.inputFocus,
            isHover: _vm.inputHover,
            label: _vm.label,
            disable: _vm.disable,
            error: _vm.areaError,
            isCheck: false,
            id: _vm.areaId
          },
          model: {
            value: _vm.inputVal,
            callback: function($$v) {
              _vm.inputVal = $$v
            },
            expression: "inputVal"
          }
        }),
        _c("div", {
          staticClass: "triangle-down z2",
          class: _vm.selectVisible ? "up" : ""
        }),
        _c("el-cascader", {
          staticClass: "el-cascader overlay w-normal",
          attrs: {
            value: _vm.value,
            options: _vm.options,
            props: _vm.props,
            disabled: _vm.disable
          },
          on: {
            focus: _vm.changeEventHandler,
            blur: _vm.changeEventHandler,
            "visible-change": function($event) {
              return _vm.visibleChagneHandler($event)
            },
            change: _vm.onSelectChange
          }
        }),
        (_vm.startVerific && _vm.areaError) || _vm.areaError
          ? _c("div", { staticClass: "errmsg" }, [
              _vm._v(_vm._s(_vm.areaErrmsg))
            ])
          : _vm._e()
      ],
      1
    ),
    _vm.showSchool
      ? _c(
          "div",
          { staticClass: "addSchool-line" },
          [
            _vm.addNewSchool
              ? _c("CheckInput", {
                  staticClass: "w-normal",
                  attrs: {
                    label: "学校",
                    id: _vm.schoolId,
                    startVerific: _vm.startVerific
                  },
                  on: { blur: _vm.handleBlurAddInput },
                  model: {
                    value: _vm.schoolData.schoolName,
                    callback: function($$v) {
                      _vm.$set(_vm.schoolData, "schoolName", $$v)
                    },
                    expression: "schoolData.schoolName"
                  }
                })
              : _c("FilterSelect", {
                  staticClass: "component-select",
                  attrs: {
                    label: "学校",
                    options: _vm.schoolOptions,
                    id: _vm.schoolId,
                    errmsg: _vm.schoolErrmsg,
                    startVerific: _vm.startVerific
                  },
                  on: {
                    change: _vm.handleChoiceSchool,
                    click: _vm.handleClick
                  },
                  model: {
                    value: _vm.schoolData.schoolId,
                    callback: function($$v) {
                      _vm.$set(_vm.schoolData, "schoolId", $$v)
                    },
                    expression: "schoolData.schoolId"
                  }
                }),
            _vm.isHasSchool
              ? _c(
                  "div",
                  {
                    staticClass: "addSchoolBtn",
                    on: { click: _vm.handleAddSchool }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.addNewSchool
                          ? "从已有学校填写"
                          : "没有找到你的学校？手动填写"
                      )
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }